/* unplugin-vue-components disabled */import { render } from "./OrderingCost.vue?vue&type=template&id=b9c6936c&scoped=true"
import script from "./OrderingCost.vue?vue&type=script&lang=js"
export * from "./OrderingCost.vue?vue&type=script&lang=js"

import "./OrderingCost.vue?vue&type=style&index=0&id=b9c6936c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c6936c"]])

export default __exports__